// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabsborder{
    border-bottom: none !important;
  }

.h6, h6 {
  font-size: 1rem;
}

:host ::ng-deep .tab-content{
  padding: 1rem;
}

:host ::ng-deep .layout_space{
  padding: 0%;
}

:host ::ng-deep .nav.nav-tabs.nav-underline .nav-item a.nav-link {
  padding: 0.5rem 0rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/_layout/customizer/horizontal-customizer/horizontal-customizer.component.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;EAChC;;AAEF;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".tabsborder{\n    border-bottom: none !important;\n  }\n\n.h6, h6 {\n  font-size: 1rem;\n}\n\n:host ::ng-deep .tab-content{\n  padding: 1rem;\n}\n\n:host ::ng-deep .layout_space{\n  padding: 0%;\n}\n\n:host ::ng-deep .nav.nav-tabs.nav-underline .nav-item a.nav-link {\n  padding: 0.5rem 0rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
